import {
  isAuctionRelease,
  isAvailable,
  isBlockchainAuctionRelease,
  isSoldOut,
} from '@utils/product';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { GeneratedGetDrawByProductIDsQuery } from '../../types/generated';
import { renderShopifyArtistName } from '../../utils/artists';
import { Connect } from '../Auction/Manifold/widgets/Connect';
import { Price as AuctionPrice } from '../Auction/Manifold/widgets/Price';
import { ProductPrice } from '../ProductPrice/ProductPrice';

type Props = {
  product: MultiCurrencyProduct;
  draw?: GeneratedGetDrawByProductIDsQuery['getDrawByProductIDs'][number];
};

const ProductTileDescription: React.FC<Props> = ({ draw, product }) => {
  const { t } = useTranslation('product');

  const isPriceVisible =
    isAuctionRelease(product.releaseType) ||
    product.cryptoPrice ||
    Number(product.price) > 0;
  const isPriceRange =
    product.productType === 'Collection' && !product.samePrice;
  const available = isAvailable(product);
  const { releaseType } = product;

  const getPrice = () => {
    if (isBlockchainAuctionRelease(product)) {
      if (!available && product.auctionFloorPrice) {
        return isSoldOut(product)
          ? product.auctionFloorPrice
          : `${t('auction.from')} ${product.auctionFloorPrice}`;
      }

      if (available && product.manifoldListingId) {
        return (
          <span className="product-tile">
            <Connect className="hidden" />
            <AuctionPrice
              defaultValue={product.auctionFloorPrice}
              isRanked={releaseType === 'nft_ranked_auction'}
              listingId={product.manifoldListingId.toString()}
              prefix={t('auction.from')}
            />
          </span>
        );
      }
    }

    if (
      isAuctionRelease(product.releaseType) &&
      draw?.auctionReservePrice &&
      !isSoldOut(product)
    ) {
      return null;
    }

    if (product.cryptoPrice) return product.cryptoPrice;

    return <ProductPrice price={Number(product.price)} />;
  };

  return (
    <div className="flex flex-col transition duration-300 group-hover:text-neutral-4">
      <span className="font-bold">
        {renderShopifyArtistName(product.artist)}
      </span>
      <span>{product.title}</span>

      {isPriceVisible && (
        <span className="text-neutral-4">
          {isPriceRange && <span>{t('from')}&nbsp;</span>}
          {getPrice()}
        </span>
      )}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProductTileDescription;
